import Skeleton from 'react-loading-skeleton'
import 'react-loading-skeleton/dist/skeleton.css'
import styles from './style.module.scss'

type Props = {
  count: number
}

const SkeletonLoader: React.VFC<Props> = ({ count }) => {
  return (
    <div className={styles.skeletonLoader}>
      {
        Array.from(Array(count).keys()).map(item => {
          return (
            <div key={item} className={styles.skeletonLoaderCard}>
              <Skeleton
                height={160}
                borderRadius="8px"
                style={{ marginBottom: "1.2rem" }}
              />
              <Skeleton
                height={20}
                borderRadius="4px"
                style={{ marginBottom: "0.8rem" }}
              />
              <div>
                <Skeleton
                  height={15}
                  borderRadius="4px"
                  width={"40%"}
                  style={{ marginBottom: "0.4rem" }}
                />
                <Skeleton
                  height={15}
                  borderRadius="4px"
                  width={"80%"}
                />
              </div>
            </div>
          )
        })
      }
    </div>
  )
}

export { SkeletonLoader }
